import { CommonModule } from '@angular/common';
import {
  Component, ChangeDetectionStrategy, Input, ViewChild, ElementRef, Renderer2, OnChanges, AfterViewInit, SimpleChanges
} from '@angular/core';

import { isEmpty, isNullOrUndefined } from '@app/util/util';
import {
  TypographyFontSize, TypographyFontFamily, TypographyColor, TypographyTag, TypographyDefaultTag
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-ds-typography',
  templateUrl: './typography.component.html',
  styleUrls: ['./typography.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class TypographyDsComponent implements OnChanges, AfterViewInit {

  @Input() size = TypographyFontSize.Minor;
  @Input() fontFamily = TypographyFontFamily.Regular;
  @Input() tag: TypographyTag = TypographyDefaultTag;
  @Input() text: string;
  @Input() color: TypographyColor;
  @Input() ellipsis: boolean;
  @Input() textDecoration = null;
  @Input() lineClamp: number;

  @ViewChild('typographyDs') typographyDs: ElementRef;

  constructor(
    private readonly renderer: Renderer2,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!isEmpty(changes) && this.typographyDs?.nativeElement) {
      this.renderer.setProperty(this.typographyDs.nativeElement, 'innerHTML', '');
      this.createTag();
    }
  }

  ngAfterViewInit(): void {
    this.createTag();
  }

  get clamp(): boolean {
    return this.ellipsis && !isNullOrUndefined(this.lineClamp) && !!this.lineClamp;
  }

  private createTag(): void {
    const htmlTg = this.tag ?? TypographyDefaultTag;
    const tagElement = this.renderer.createElement(htmlTg);
    if (tagElement && this.typographyDs?.nativeElement) {
      const tagClass = 'typographyDs__cont__tag';
      this.renderer.addClass(tagElement, tagClass);
      this.renderer.addClass(tagElement, `${tagClass}--${this.size}`);
      this.renderer.addClass(tagElement, `${tagClass}--${this.fontFamily}`);
      this.renderer.addClass(tagElement, `${tagClass}--${this.color}`);
      if (this.ellipsis) {
        this.renderer.addClass(tagElement, 'ellipsis');
      }
      if (!isNullOrUndefined(this.textDecoration)) {
        this.renderer.setStyle(tagElement, 'text-decoration', this.textDecoration);
      }
      if (this.clamp) {
        this.renderer.addClass(tagElement, 'clamp');
        this.renderer.setStyle(tagElement, '-webkit-line-clamp', this.lineClamp);
      }
      this.renderer.setProperty(tagElement, 'innerHTML', this.text ?? '');
      this.renderer.appendChild(this.typographyDs.nativeElement, tagElement);
    }
  }

}
